<template>
<div id="dieji">
  <div  class="base">
    <div class="left">
      <div class="left-title">
        <div class="top">
          {{ lineData.title }}
        </div>
        <div class="border"></div>
        <div class="center">
          {{ lineData.listDict }}
        </div>
        <div class="border"></div>
        <div class="bottom">百望堂</div>
      </div>
      <div class="content">
        <div
          class="cont1"
          v-for="item in lineData.topDeviceList"
          :key="item.id"
        >
          <div class="top">{{ item.levelName }}</div>

          <div class="center-box">
            <!-- item.childList -->
            <div class="center" v-for="item2 in item.childList" :key="item2.id">
              {{ item2.xifus }}
            </div>
          </div>
          <div class="bottom-box">
            <div class="bottom" v-for="item2 in item.childList" :key="item2.id">
              <div style="letterSpacing:1px;font-weight: 600">
                {{ item2.surname }}
                {{ item2.name }}
              </div>
               <div style="letterSpacing:1px;">
              {{ item2.broThDate }}
              {{ item2.existUser }}
              {{ item2.xifus }}
              {{ item2.formDict }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
  
  <script>
import { lineChildList,uploadMy } from "@/api";

export default {
  name: "dieji",
  data() {
    return {
      id: "",
      lineData: [],
      htmlTitle: "宝塔式",
      isDownload: false,
      pdfId:'',
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.pdfId = this.$route.query.pdfId;
    this.isDownload = this.$route.query.isDownload;
    this.htmlTitle = this.$route.query.htmlTitle;
    lineChildList(this.id).then((res) => {
      this.lineData = res.data;
    });

     setTimeout(()=>{

     },3000);

  },
  updated(){
        this.$nextTick(() => {
      this.getPdf(document.getElementById("dieji"), this.htmlTitle,this.isDownload).then(
        (res) => {
          if (res) {
            console.log("准备上传");
            this.UploadPdf(res);
          } else {
            console.log("不上传");
          }
        }
      );
    });
  },
  mounted(){

  },
    methods: {
    //上传pdf接口
    UploadPdf(res) {
      //res拿到base64的pdf
      let pdfBase64Str = res;
      var myfile = this.dataURLtoFile(pdfBase64Str, this.title + ".pdf"); //调用一下下面的转文件流函数
      var formdata = new FormData();
      formdata.append("file", myfile); // 文件对象
      formdata.append("pdfId", this.pdfId); // 文件对象
      //该uploadMy为接口，直接以formdata格式传给后台
      uploadMy(formdata)
        .then((res) => {
          console.log("上传pdf接口", res);
        })
        .catch((err) => {
          console.log("上传pdf接口", err);
        });
    },
    /*
将base64转换为文件,接收2个参数，第一是base64，第二个是文件名字
最后返回文件对象
*/
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.base {
      width: 1920px;
  min-width: 100%;
  min-height: 600px;
  border: 2px solid #000;
  overflow-wrap: break-word;
  padding: 50px 0;
}
.base .left {
  min-width: 75%;
  min-height: 400px;
  border: 1px solid #000;
  border-left: none;
  display: flex;
}
.base .left .left-title {
  width: 50px;
  min-height: 400px;
  border-right: 1px solid #000;
}
.base .left .left-title .top {
  width: 50px;
  writing-mode: vertical-lr;
  padding: 10px;
  text-align: center;
}
.base .left .left-title .center {
  height: 60%;
  writing-mode: vertical-lr;
  text-align: center;
  padding: 10px;
}
.base .left .left-title .bottom {
  height: 20%;
  writing-mode: vertical-lr;
  text-align: center;
  padding: 10px;
}
.base .left .left-title .border {
  width: inherit;
  height: 20px;
  background-color: #000;
}

.base .left .content {
  min-width: 100%;
  min-height: 600px;
  display: flex;
}
.base .left .content .cont-border {
  width: 100%;
  height: 1px;
  background: #000;
}
.base .left .content .cont1 {
  min-width: 15%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #000;
}
.base .left .content .cont1 .top {
  flex: 0 1 20%;
  border-bottom: 1px solid #000;
  writing-mode: vertical-lr;
  box-sizing: border-box;
  padding: 0 20px;
  vertical-align: middle;
  font-weight: bold;
  font-size: 28px;
}
.base .left .content .cont1 .center-box {
  display: flex;
}
.base .left .content .cont1 .center-box .center {
  flex: 0 1 20%;
  border-bottom: 1px solid #000;
  writing-mode: vertical-lr;
  box-sizing: border-box;
  padding: 0 10px;
}
.base .left .content .cont1 .bottom-box {
  display: flex;
}
.base .left .content .cont1 .bottom-box .bottom {
  flex: 0 1 60%;
  border-bottom: 1px solid #000;
  writing-mode: vertical-lr;
  text-align: left;
  box-sizing: border-box;
  padding: 10px;
}
</style>
  


// WEBPACK FOOTER //
// src/view/dieji.vue